import dayjs from 'dayjs';

const formatSplit = (s: any, type: any) => {
    if (s === null) {
        return null;
    }
    if (s === '') {
        return '';
    }
    if (s === 0 && type === 0) {
        return '0.00';
    }
    if (s === 0 && type !== 0) {
        return '0';
    }
    s = s < 0 && type === 0 ? s.toString().replace(/^(\d*)$/, '$1.') + '.' : s.toString().replace(/^(\d*)$/, '$1.');
    s = (s + '00').replace(/(\d*\.\d\d)\d*/, '$1');
    s = s.replace('.', ',');
    const re = /(\d)(\d{3},)/;
    while (re.test(s)) s = s.replace(re, '$1,$2');
    s = s.replace(/,(\d\d)$/, '.$1');

    if (type !== 0) {
        const a = s.split('.');
        if (a[1] === '00') {
            s = a[0];
        }
    }
    return s;
};
/*const formatPhone = (num: any) => {
    if (!num) return '-';
    if (num.length === 10) return `+44 ${num.slice(0, 2)} ${num.slice(2, 6)} ${num.slice(6)}`;
    else return num;
};*/
const formatPhone = (num: any) => {
    if (!num) return '';
    if (num.length === 10 && num.slice(0, 1) === '7') return `${num.slice(0, 2)} ${num.slice(2, 6)} ${num.slice(6)}`;
    else if (num.length === 11 && num.slice(0, 2) === '07')
        return `${num.slice(0, 3)} ${num.slice(3, 7)} ${num.slice(7)}`;
    else return num;
};
const formatMobileNumber = (s: string | null): string | undefined => {
    if (!s) {
        return '';
    }
    if (s.length == 11) {
        return s.slice(0, 3) + ' ' + s.slice(3, 7) + ' ' + s.slice(7, 11);
    } else if (s.length == 8) {
        return s.slice(0, 4) + ' ' + s.slice(4, 8);
    } else if (s.length == 9) {
        return s.slice(0, 3) + ' ' + s.slice(3, 6) + ' ' + s.slice(6, 9);
    } else if (s.length == 10) {
        return s.slice(0, 2) + ' ' + s.slice(2, 6) + ' ' + s.slice(6, 10);
    } else {
        return s;
    }
};
const formatNumer = (num: string) => {
    const temp = num
        .replace(/[^\d.]/g, '')
        .replace(/^\./g, '')
        .replace(/\.{2,}/g, '')
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
        .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
    return Number(temp);
};
const formatNum = (s: string) => {
    const numParts = s.toString().split('.');
    numParts[0] = numParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return numParts.join('.');
};
function isCurrentWeek(pastTime: number) {
    const today = new Date(new Date().toLocaleDateString());
    let day = today.getDay();
    day = day == 0 ? 7 : day;
    const oneDayTime = 60 * 60 * 24 * 1000;
    const monday = new Date(today.getTime() - oneDayTime * (day - 1));
    const nextMonday = new Date(today.getTime() + oneDayTime * (8 - day));
    if (monday.getTime() <= pastTime && nextMonday.getTime() > pastTime) {
        return true;
    } else {
        return false;
    }
}
const formatTimeStamp = (e: any) => {
    if (!e) return '-';
    if (typeof e === 'string') e = Number(e);
    if (e < 10000000000) e = e * 1000;
    const time = dayjs(e).format('DD.MM.YYYY HH:mm');
    const hourMinute = time.split(' ')[1];
    const hour = Number(hourMinute.split(':')[0]);
    const hourFinal = hour > 12 ? hour - 12 : hour;
    const minute = hourMinute.split(':')[1];
    return `${time.split(' ')[0]}, ${hourFinal}:${minute}${hour > 11 ? ' PM' : ' AM'}`;
    // 16.05.2022, 7:35 PM
};
const formatTimeStamp24 = (e: any) => {
    if (!e) return '-';
    if (typeof e === 'string') e = Number(e);
    if (e < 10000000000) e = e * 1000;
    const time = dayjs(e).format('DD.MM.YYYY | HH:mm');
    return `Date Added: ${time}`;
    // 16.05.2022, 7:35 PM
};
/**
 * MMM DD, YYYY
 * @param e
 * @returns
 */
const formatTimeMDY = (e: string | null) => {
    if (!e) return '-';
    const time = dayjs(e).format('MMM DD, YYYY');
    return time;
    // 16.05.2022, 7:35 PM
};
/**
 * hh:mm A, MMM DD YYYY
 * @param e
 * @returns
 */
const formatTimeHMDY = (e: any) => {
    if (!e) return '-';
    const time = dayjs(e).format('hh:mm A, MMM DD YYYY');
    return time;
    // 16.05.2022, 7:35 PM
};
const formatTimeHMSMDY = (e: any) => {
    if (!e) return '-';
    const time = dayjs(e).format('HH:mm:ss MMM DD, YYYY');
    return time;
};
const formatWorkPeriod = (startTime, endTime) => {
    const today = dayjs();
    const isToday = dayjs(startTime).isSame(today, 'day');

    if (dayjs(startTime).isSame(dayjs(endTime), 'day')) {
        return `${dayjs(startTime).format('h:mm A')}~${
            dayjs(endTime).format('h:mm A, ') + (isToday ? 'Today' : dayjs(startTime).format('D MMM YYYY'))
        }`;
    } else {
        return `${dayjs(startTime).format('h:mm A, D MMM YYYY')} to ${dayjs(endTime).format('h:mm A, D MMM YYYY')}`;
    }
};
const getTimeUntilStart = (workStartDate, workStartTime) => {
    const startDateTime = dayjs(workStartDate + 'T' + workStartTime);
    const now = dayjs();
    const diff = startDateTime.diff(now, 'minute');
    if (diff > 1440) {
        const days = Math.ceil(diff / 1440);
        return `${days} Day(s)`;
    } else if (diff > 60) {
        const hours = Math.ceil(diff / 60);
        return `${hours} hour(s)`;
    } else {
        return `${diff} min(s)`;
    }
};
function formatTimeMin(minutes) {
    if (minutes < 60) {
        return minutes > 1 ? minutes + 'mins' : minutes + 'min';
    } else {
        const hours = Math.floor(minutes / 60);
        const remainingMinutes = minutes % 60;
        return `${hours + 'h '} ${remainingMinutes > 1 ? remainingMinutes + 'mins' : remainingMinutes + 'min'}`;
    }
}
function formatFileTime(e) {
    if (!e) return '-';
    const timeY = dayjs(e).format('DD MMM YYYY');
    const timeM = dayjs(e).format('hh:mm A');
    return `${timeY} at ${timeM}`;
}
const customFormat = (time: string | null, foramtRule: string) => {
    if (!time) return '-';
    return dayjs(time).format(foramtRule);
};
const countFormatter = {
    formatter: (info: { value: string; count: number; maxLength?: number }) => `${info.count}/${info.maxLength}`,
};
export default {
    formatSplit,
    isCurrentWeek,
    formatPhone,
    formatNumer,
    formatNum,
    formatTimeStamp,
    formatTimeStamp24,
    formatTimeMDY,
    formatMobileNumber,
    formatWorkPeriod,
    getTimeUntilStart,
    formatTimeHMDY,
    formatTimeHMSMDY,
    formatTimeMin,
    formatFileTime,
    customFormat,
    countFormatter,
};
